module.exports = __webpack_public_path__ + "img/05032023.277e7eec.png";